import React from 'react';
import { Brain, ArrowRight } from 'lucide-react';
export function RetouchSection() {
  return <section className="py-12 px-6 bg-[#0f0f23]" data-id="element-192">
      <div className="bg-gradient-to-br from-[#1a1a2e] to-[#13132b] border border-white/10 rounded-3xl p-8 relative overflow-hidden" data-id="element-193">
        <div className="absolute -right-4 -top-4 text-white/5" data-id="element-194">
          <Brain className="w-32 h-32" data-id="element-195" />
        </div>

        <div className="relative z-10" data-id="element-196">
          <h3 className="text-2xl font-bold text-yellow-400 mb-6" data-id="element-197">
            Imaginá esto…
          </h3>

          <p className="text-gray-300 leading-relaxed mb-8 text-lg" data-id="element-198">
            Llegás a tu clase y ya sabés exactamente qué hacer. Tenés
            actividades listas. Sabés cómo explicar el tema. Tenés ejercicios
            preparados. Y todo está organizado.
          </p>

          <div className="space-y-3 mb-8" data-id="element-199">
            <div className="flex items-center gap-2 text-gray-200" data-id="element-200">
              <ArrowRight className="w-4 h-4 text-yellow-500" data-id="element-201" />
              <span className="font-medium" data-id="element-202">Sin improvisar</span>
            </div>
            <div className="flex items-center gap-2 text-gray-200" data-id="element-203">
              <ArrowRight className="w-4 h-4 text-yellow-500" data-id="element-204" />
              <span className="font-medium" data-id="element-205">Sin estrés</span>
            </div>
            <div className="flex items-center gap-2 text-gray-200" data-id="element-206">
              <ArrowRight className="w-4 h-4 text-yellow-500" data-id="element-207" />
              <span className="font-medium" data-id="element-208">Sin perder tiempo</span>
            </div>
          </div>

          <div className="bg-yellow-500/10 border-l-4 border-yellow-500 p-4 rounded-r-lg" data-id="element-209">
            <p className="font-bold text-white" data-id="element-210">
              Eso es lo que este sistema hace por vos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}